// Centralized brand + contact info for Sweet Rose Cookies
export const BRAND = {
  name: "Sweet Rose Cookies",
  short: "Sweet Rose",
  tagline: "Bespoke sugar cookies for life's sweetest moments.",
  address: "1809 Settlement Wy, Aubrey, TX 76227",
  phone: "(940) 305-8803",
  phoneHref: "tel:+19403058803",
  hours: "Mon–Fri · 9 AM – 5 PM",
  rating: "5.0",
  facebook: "https://www.facebook.com/share/18S8n92AXr/",
  mapsUrl: "https://maps.app.goo.gl/2WcSm6vSZ5fUB6198",
  email: "byjimenez88@gmail.com",
};

// Real Sweet Rose Cookies photography
export const HERO_IMAGE =
  "https://customer-assets.emergentagent.com/job_custom-cookie-market/artifacts/rvngbgms_IMG-20260421-WA0161.jpg";

export const AI_BG_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/970f6ff4-baf0-4254-8a80-5e7633182b19/images/22586bee658305cc367fb6a6ec7b39398309edb854dd7dd98686144859e32c05.png";

export const STORY_IMAGE =
  "https://customer-assets.emergentagent.com/job_custom-cookie-market/artifacts/ggvyfct3_IMG-20260421-WA0165.jpg";
